function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { asMultiStyleConfig } from '../../../../utils/theme';
var buttonBaseStyles = {
  minW: '2rem',
  minH: '2rem',
  fontSize: 'md',
  borderRadius: '1.375rem',
  bg: 'transparent',
  display: 'inline-flex',
  boxSizing: 'border-box',
  border: 0,
  appearance: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 150ms ease',
  userSelect: 'none',
  position: 'relative',
  whiteSpace: 'nowrap',
  verticalAlign: 'middle',
  outline: 'none',
  _hover: {
    bg: 'blue.1140'
  },
  _active: {
    bg: 'blue.1150'
  },
  _focus: {
    boxShadow: "\n    0 0 0.125rem 0.125rem #00CAFF,\n    0 0 0.125rem 0.125rem #4CAAF0",
    outline: 'none'
  },
  '& svg': {
    color: 'blue.275'
  }
};
var buttonBaseResponsiveStyles = {
  display: 'flex',
  alignItems: 'center',
  px: '1rem',
  height: '2.75rem',
  color: 'blue.275',
  justifyContent: 'center',
  _disabled: {
    color: 'grey.800',
    borderColor: 'grey.450',
    pointerEvents: 'none'
  },
  borderRadius: '.188rem',
  border: 'solid 1px',
  borderColor: 'blue.275',
  minWidth: '8.25rem',
  '& svg': {
    display: 'none'
  }
};
export var Pagination = asMultiStyleConfig({
  parts: ['container', 'previous', 'previousResponsive', 'next', 'nextResponsive', 'pageNumber', 'pageNumberList', 'paginationMain'],
  defaultProps: {
    colorScheme: 'idle'
  },
  baseStyle: {
    paginationMain: {
      bgColor: 'grey.990',
      pl: '1.3rem',
      pr: '1.8rem',
      py: '1.25rem',
      mt: '1.5rem'
    },
    container: {
      display: 'flex',
      '& span': {
        fontSize: '1rem',
        mx: '.5rem',
        fontWeight: '700'
      }
    },
    previous: _objectSpread(_objectSpread({}, buttonBaseStyles), {}, {
      ml: -1,
      color: 'blue.275',
      borderRadius: '.188rem'
    }),
    previousResponsive: _objectSpread(_objectSpread({}, buttonBaseStyles), buttonBaseResponsiveStyles),
    next: _objectSpread(_objectSpread({}, buttonBaseStyles), {}, {
      mr: -1,
      color: 'blue.275',
      borderRadius: '.188rem'
    }),
    nextResponsive: _objectSpread(_objectSpread({}, buttonBaseStyles), buttonBaseResponsiveStyles),
    pageNumberList: {
      display: 'flex',
      alignItems: 'center',
      listStyle: 'none'
    },
    pageNumber: _objectSpread(_objectSpread({}, buttonBaseStyles), {}, {
      _disabled: {
        bg: 'blue.275',
        color: 'white',
        fontWeight: 'bold',
        cursor: 'default'
      }
    })
  }
});